import { initAccordion } from "./accordion";

function run() {
  initAccordion();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run, { once: true });
} else {
  run();
}
document.addEventListener("astro:page-load", run);
